import React, { useState } from "react";
import "./filter-task-button.component.scoped.scss";
import { Button } from "@material-ui/core";
import i18n from "../../i18n";

export default function FilterTaskButton(props: any) {
  const [active, setBtnState]: any = useState(props.state === "active" ? 0 : 1);
  const language = i18n.language;
  const { toggleActiveFilter } = props;

  const toggleState = () => {
    const { task } = props;
    setBtnState(!active);
    const selector = language === "de"
      ? 'nameDe'
      : 'nameEn';
    const taskName = task[selector];
    toggleActiveFilter(taskName);
  };

  return (
    <Button
      className={`task-btn text-capitalize ${
        props.state === "inactive" ? "" : active ? "active" : ""
      }`}
      variant="contained"
      color="primary"
      onClick={toggleState}
    >
      <img src={props.task.icon} alt="task icon"/>
      <span>{language === 'de' ? props.task.nameDe : props.task.nameEn}</span>
    </Button>
  );
}
